import { ReactNode } from 'react'
import styles from '../shared-ui-footer.module.css'
import { footerLinkClickTrackingEvent } from '../tracking'
import { useAnalytics } from '@cinch-nx/shared-analytics'

export type SocialNetworkButtonProps = {
  icon: ReactNode
  link: string
  name: string
}

export const SocialNetworkButton = ({
  icon,
  link,
  name,
}: SocialNetworkButtonProps) => {
  const { trackEvent } = useAnalytics()

  return (
    <a
      href={link}
      className={styles.link}
      onClick={() => trackEvent(footerLinkClickTrackingEvent(link, name))}
      rel="noopener noreferrer"
      target="_blank"
      aria-label={name}
    >
      {icon}
    </a>
  )
}
